module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Schenkon-c83b3b369a3353d8a2b10f5a5efa1029.svg";